import { render, staticRenderFns } from "./KOLDetails.vue?vue&type=template&id=37d3e2ba&scoped=true"
import script from "./KOLDetails.vue?vue&type=script&lang=js"
export * from "./KOLDetails.vue?vue&type=script&lang=js"
import style0 from "./KOLDetails.vue?vue&type=style&index=0&id=37d3e2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d3e2ba",
  null
  
)

export default component.exports